import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { baseUrl, gatewayFile } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  private url = baseUrl + gatewayFile;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getAlerts(): Observable<any[]> {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getAlerts' })
    .pipe(
      catchError(this.handleError('getAlerts', []))
    );
  }

  getAlertCount(): Observable<any[]> {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getAlertsCount' })
    .pipe(
      catchError(this.handleError('getAlerts', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
